// Cada pantalla solo se muestra a quien su rol le permite verla, y quien la ve
// también puede crear y editar en ella (el backend valida lo mismo).
export function puedeCrear(usuario) {
  return Boolean(usuario?.acceso);
}
